import type { RouteLocationNormalized } from 'vue-router';

/**
 * Route guard for the lesson editor's dynamic `:id`: a missing or empty param can't identify a
 * playlist, so send the teacher back to the Lesson Hub. Lives here (not inline in the page) so it
 * can be unit-tested — it runs in the routing pipeline, out of reach of a mounted-component spec.
 */
export const editLessonIdGuard = (to: RouteLocationNormalized) => {
  if (typeof to.params.id !== 'string' || to.params.id.length === 0) {
    return navigateTo(clusterRedirectPath('/educators/lessons'));
  }
};
